export enum BannerTypeEnum {
  Html = 1,
  Image = 2,
}
